import Link from "components/Link"
import { PRODUCT_URL, TRUST_AND_SECURITY_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import FeaturesList, { ListItem } from "components/ui/FeaturesList"
import Heading from "components/ui/Heading"

function InteractiveAnalyticsAnywhereSection() {
  const { getAsset } = usePageAssets()
  const expansiveSetOfVisualizations = getAsset(
    "ed-expansive-set-of-visualizations-svg"
  )
  const seamlesslyScale = getAsset("ed-seamlessly-scale-svg")
  const secureAccessControl = getAsset("ed-secure-access-control-svg")
  const quicklyDeployDashboards = getAsset("ed-quickly-deploy-dashboards-svg")
  return (
    <Container section>
      <Heading
        label="Interactive Analytics Anywhere"
        title={
          <>
            Build and share dashboards securely.
            <br />
            We take care of the rest.
          </>
        }
        subtitle={
          <>
            Customize charts and dashboards for embedding just like how you’d
            build and configure any other chart and dashboard in{" "}
            <Link className="text-lush" href={PRODUCT_URL}>
              Preset Cloud
            </Link>
            . A few extra steps would get them live in any custom application.
          </>
        }
        decoration="border"
      />
      <FeaturesList className="mt-10">
        <ListItem
          image={expansiveSetOfVisualizations}
          title="Choose from an expansive set of visualizations"
          description={
            <>
              Preset comes pre-loaded with over 40+ visualization types, so you
              can serve your customers with tailored analytics experiences.
            </>
          }
        />
        <ListItem
          image={seamlesslyScale}
          title="Seamlessly scale to all of your users"
          description={
            <>
              Quickly scale from 0 to thousands of users through automated
              provisioning without compromising on dashboard speed and
              performance.
            </>
          }
        />
        <ListItem
          image={secureAccessControl}
          title="Secure access control and granular permissions with row-level security and SSO"
          description={
            <>
              Easily provision data access permissions to all your users with
              row-level security. Or bring in your own user management by
              implementing SAML SSO integration. Learn more about{" "}
              <Link className="text-lush" href={TRUST_AND_SECURITY_URL}>
                Trust and Security within Preset
              </Link>
              .
            </>
          }
        />
        <ListItem
          image={quicklyDeployDashboards}
          title="Deploy dashboards that match the look and feel of your application"
          description={
            <>
              With Preset’s Embedded SDK, quickly integrate your dashboard with
              your native data application with your color palettes and custom
              CSS.
            </>
          }
        />
      </FeaturesList>
    </Container>
  )
}

export default InteractiveAnalyticsAnywhereSection
